const collectValidationMessages = errors => {
  if (!errors || typeof errors !== "object") return []

  return Object.values(errors)
    .map(error => {
      if (typeof error === "string") return error
      return error?.message || error?.properties?.message || ""
    })
    .filter(Boolean)
}

export const getApiErrorMessage = (
  error,
  fallback = "Something went wrong. Please try again."
) => {
  if (typeof error === "string" && error.trim()) return error
  if (!error || typeof error !== "object") return fallback

  const data = error?.response?.data || error?.data
  if (data && data !== error) {
    const dataMessage = getApiErrorMessage(data, "")
    if (dataMessage) return dataMessage
  }

  const validationMessages = collectValidationMessages(error.errors)
  if (validationMessages.length) return validationMessages.join(" ")

  if (typeof error.message === "string" && error.message.trim()) {
    return error.message
  }
  if (error.message && error.message !== error) {
    const nestedMessage = getApiErrorMessage(error.message, "")
    if (nestedMessage) return nestedMessage
  }
  if (typeof error._message === "string" && error._message.trim()) {
    return error._message
  }
  if (typeof error.error === "string" && error.error.trim()) {
    return error.error
  }

  return fallback
}
